import api from 'contexts/api';
import {
  Box, FormLabel, FormControl, Input, Icon, Select, SimpleGrid, Button, Text, Spinner, SelectField,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useToast
} from "@chakra-ui/react";
import { CalendarIcon, DownloadIcon } from '@chakra-ui/icons';
import { HiOutlineShoppingCart } from "react-icons/hi";
import IconBox from "components/icons/IconBox";
import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from 'react-router-dom';
import { TableContainer, Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react";
import Pagination from 'views/admin/AnaliticoProduto/components/paginate';
import AsyncStorage from '@react-native-async-storage/async-storage';
import * as XLSX from 'xlsx/xlsx.mjs';
import { MultiSelect } from "react-multi-select-component";
// import cadastroExpedicao from './components/cadastroExpedicao';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

import DataDisplay from './components/table';
import CadastroExpedicao from './components/cadastroExpedicao';
import ModalComponent from './components/modal';

function removeObjectsByKey(objects, keysToRemove) {
  return objects.map(obj => {
    const newObj = {};
    for (let key in obj) {
      if (!keysToRemove.includes(key)) {
        newObj[key] = obj[key];
      }
    }
    return newObj;
  });
}

function generatePDF(excel, total, filtros) {

  let tableFiltro = transformaFiltros([filtros]);
  let result = [];

  for (let i = 0; i < tableFiltro.length; i++) {
    const rowEntries = Object.entries(tableFiltro[i]);
    const filtrosConvertidos = rowEntries.reduce((acc, [key, value]) => {
      let convertedValue = value;
      if (typeof value === 'object' && value !== null && value.props && value.props.children) {
        convertedValue = value.props.children.toString(); // Converte o objeto em uma string
      }
      acc.push({ [key]: convertedValue });
      return acc;
    }, []);
    result.push(filtrosConvertidos);
  }

  const doc = new jsPDF('landscape');
  let tableData = [];

  const data = excel;
  const headers = Object.keys(data[0]).slice(0, 12);
  const headers_total = Object.values(total).slice(0, 12).map(obj => Object.values(obj)[0]);

  for (let i = 0; i < data.length; i++) {
    const rowValues = Object.values(data[i]).slice(0, 12);
    const convertedRowValues = rowValues.map((value) => {
      if (typeof value === 'object' && value !== null && value.props && value.props.children) {
        return value.props.children.toString(); // Converte o objeto em uma string
      }
      return value;
    });
    tableData.push(convertedRowValues);
  }


  doc.setFontSize(18);
  doc.text('Relatório Quadro de Vendas', 15, 15);

  doc.setFontSize(10);
  doc.text('Filtros:', 15, 25);

  const filters = result[0]; // Obtém os filtros do resultado

  if (filters) {
    let currentX = 35; // Posição X inicial para os valores dos filtros
    const y = 25; // Posição Y para a primeira linha dos filtros

    const mergedFilters = filters.reduce((acc, filter) => {
      const [label, value] = Object.entries(filter)[0]; // Obtém a legenda e o valor do filtro
      return `${acc}${label} ${value}, `; // Concatena a legenda e o valor com vírgula
    }, '');

    // Remove a vírgula extra no final
    const mergedFiltersText = mergedFilters.slice(0, -2);

    // Define o tamanho da fonte para os filtros
    doc.setFontSize(8);

    // Verifica se o texto dos filtros cabe em uma linha
    const textWidth = doc.getStringUnitWidth(mergedFiltersText) * doc.internal.getFontSize();
    const maxWidth = doc.internal.pageSize.getWidth() - currentX - 10; // Largura máxima disponível
    let filteredText = mergedFiltersText;

    if (textWidth > maxWidth) {
      // O texto excede a largura máxima, então é necessário quebrar em várias linhas
      const lines = doc.splitTextToSize(mergedFiltersText, maxWidth);
      filteredText = lines.join('\n'); // Concatena as linhas com quebras de linha
    }

    // Adiciona o texto dos filtros no documento PDF
    doc.text(filteredText, currentX, y);
  }

  // Define a margem superior da tabela
  const tableMarginTop = 35;

  // Adicionar cabeçalhos
  doc.autoTable({
    head: [headers_total, headers], // Adicione os cabeçalhos em ordem
    body: tableData,
    startY: tableMarginTop, // Ajuste a posição vertical para evitar sobreposição com o título e a legenda
    columnWidth: 'auto',
    styles: {
      fontSize: 6,
      cellStyles: {
        overflow: 'linebreak', // Quebra de linha automática para células
      },
    },
  });

  doc.save('quadro_diario.pdf');
}

function calcularTotalizadores(array) {
  const totalizadores = {};


  array.forEach((obj) => {
    for (const key in obj) {
      const valor = obj[key];

      if (typeof valor === 'string' && valor.includes('R$')) {
        const valorNumerico = parseFloat(valor.replace(/[^\d,-]+/g, '').replace(',', '.'));
        if (!isNaN(valorNumerico)) {
          if (totalizadores[key]) {
            totalizadores[key] += valorNumerico;
          } else {
            totalizadores[key] = valorNumerico;
          }
        }
      } else if (key === 'Quantidade') {
        const valorNumerico = parseFloat(valor);
        if (!isNaN(valorNumerico)) {
          if (totalizadores[key]) {
            totalizadores[key] += valorNumerico;
          } else {
            totalizadores[key] = valorNumerico;
          }
        }
      } else {
        if (!totalizadores[key]) {
          totalizadores[key] = '';
        }
      }
    }
  });

  const resultado = [];

  for (const key in totalizadores) {
    let value = totalizadores[key];
    if (key !== 'Quantidade') {
      if (key === 'Ticket Medio') {
        const ticketMedioValue = parseFloat(totalizadores['VT. Vendas']) / totalizadores['Quantidade'];
        value = ticketMedioValue !== NaN ? formatarValor(ticketMedioValue) : '';
      } else {
        value = totalizadores[key] !== '' ? formatarValor(totalizadores[key]) : '';
      }
      // value = totalizadores[key] !== '' ? `${formatarValor(totalizadores[key])}` : '';
    }
    resultado.push({
      [`Total ${key}`]: value,
    });
  }

  return resultado;
}

const formatDate = (date) => {
  const year = date.getFullYear();
  let month = (date.getMonth() + 1).toString();
  if (month.length === 1) {
    month = '0' + month;
  }
  let day = date.getDate().toString();
  if (day.length === 1) {
    day = '0' + day;
  }
  return `${year}-${month}-${day}`;
};

function formatarDataHora(valor) {
  if (valor === null || valor === undefined) {
    return "Sem Data";
  }

  const data = new Date(`${valor}T00:00`);
  if (isNaN(data)) {
    return "Sem Data";
  }

  const dia = ("0" + data.getDate()).slice(-2);
  const mes = ("0" + (data.getMonth() + 1)).slice(-2);
  const ano = data.getFullYear();

  return `${dia}/${mes}/${ano}`;
}

function transformaFiltros(data) {

  console.log(data)
  return data.map((item) => {
    const filtro = {};

    if (item.empresa) {
      filtro['Empresa: '] = item.empresa;
    }

    if (item.TipoData) {
      filtro['Tipo Data: '] = item.TipoData;
    }

    if (item.formas) {
      filtro['Forma Pagamento: '] = item.formas;
    }

    if (item.grupo) {
      filtro['Grupo Lançamento: '] = item.grupo;
    }

    if (item.cliente) {
      filtro['Cliente: '] = item.cliente;
    }

    if (item.grupoPessoa) {
      filtro['Grupo do Cliente: '] = item.grupoPessoa;
    }

    if (item.centro) {
      filtro['Centro de Custo: '] = item.centro;
    }

    if (item.banco) {
      filtro['Banco: '] = item.banco;
    }

    if (item.cidade) {
      filtro['Cidade: '] = item.cidade;
    }

    if (item.uf) {
      filtro['UF:'] = item.uf;
    }

    if (item.vendedor) {
      filtro['Vendedor: '] = item.vendedor;
    }

    if (item.plano) {
      filtro['Plano de Contas: '] = item.plano;
    }

    if (item.inicio) {
      filtro['Data Inicio: '] = formatarDataHora(item.inicio);
    }

    if (item.fim) {
      filtro['Data Final: '] = formatarDataHora(item.fim);
    }

    return filtro;
  });
}

const decodeStatus = (status) => {
  switch (status) {
    case 0:
      return "Aguardando";
    case 2:
      return "Separação";
    case 4:
      return "Despachada";
    // Adicione mais cases conforme necessário para outros valores de status
    default:
      return "Desconhecido";
  }
};

function generateTableData(analitico, dataAtual) {
  // console.log(analitico)
  if (analitico.length === 0) {
    const keys = [
      "ID",
      "Cídigo",
      "Códigos Vendas",
      "Empresa",
      "Status",
      "Data Emissao",
      "Transportadora",
      "Data Despacho",
    ];

    const emptyObject = {};
    keys.forEach(key => {
      emptyObject[key] = '';
    });

    return [emptyObject];
  }
  return analitico.map((item) => ({
    "ID": item._id,
    "Codigo": item.Codigo,
    "Códigos Vendas": item.Codigos,
    "Empresa": item.Empresa,
    "Status": decodeStatus(item.Status),
    "Data Emissao": item.DataEmissao,
    "Transportadora": item.Transportadora,
    "Data Despacho": item.DataDespacho,
  }));
}

function gerarExcel(dados, objeto) {
  const formatarValorParaExcel = (valor) => {
    if (typeof valor === "string" && valor.includes("R$")) {
      const valorLimpo = valor
        .replace("R$", "") // Remove "R$"
        .replace(/\s/g, "") // Remove espaços
        .replace(/\./g, "") // Remove separadores de milhares
        .replace(",", "."); // Substitui vírgula decimal por ponto decimal
      return parseFloat(valorLimpo) || 0; // Converte para número e retorna 0 se NaN
    }
    return valor; // Retorna o valor original se não for string no formato "R$"
  };

  // Mapear e formatar os dados para Excel
  const dadosFormatados = dados.map((item) => {
    const itemFormatado = { ...item };
    for (const chave in itemFormatado) {
      if (typeof itemFormatado[chave] === "string" && itemFormatado[chave].includes("R$")) {
        itemFormatado[chave] = formatarValorParaExcel(itemFormatado[chave]);
      }
    }
    return itemFormatado;
  });

  // Criar workbook e worksheet
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(dadosFormatados);


  // Extrair os valores do objeto
  const objetoValores = Object.values(objeto).map(item => Object.values(item)[0]);

  // Obter a matriz existente dos dados
  const matrizDados = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

  // Mesclar as matrizes (inserir a nova matriz acima da matriz existente)
  const matrizFinal = [objetoValores, ...matrizDados];

  // Converter a matriz final em uma planilha
  const novaWorksheet = XLSX.utils.aoa_to_sheet(matrizFinal);

  // Adicionar a nova planilha ao workbook
  XLSX.utils.book_append_sheet(workbook, novaWorksheet, 'Sheet 1');

  XLSX.writeFile(workbook, 'quadro_diario.xlsx');
}


function formatarValor(valor) {
  if (valor === null || valor === undefined) {
    return "R$ 00,00";
  }

  const valorFormatado = valor.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return valorFormatado;
}

function getMesAtual() {
  const now = new Date();
  const mesAtual = String(now.getMonth() + 1).padStart(2, '0'); // +1 porque os meses começam de zero
  return mesAtual;
}

function obterAnoAtual() {
  const dataAtual = new Date();
  const anoAtual = dataAtual.getFullYear();
  return anoAtual;
}

function formatDatePDF(date) {
  // Função fictícia para formatar a data
  const d = new Date(date);
  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
}

function generatePDFV2(data, vendas) {
  const doc = new jsPDF();

  // Configurações de estilo
  const margin = 10;
  const padding = 5;
  const pageWidth = doc.internal.pageSize.getWidth();

  // Cabeçalho
  doc.setFontSize(10);
  doc.text("RESUMO PARA ENTREGA - ", margin + padding, margin + padding);
  const empresaUpperCase = data[0].Empresa.toUpperCase();
  doc.text(empresaUpperCase, margin + padding + doc.getTextWidth("RESUMO PARA ENTREGA - "), margin + padding);
  doc.text(`Protocolo de Saída de Mercadorias - Carga Número: ${data[0].Codigo}`, margin + padding, margin + padding + 10);

  // Desenha borda do cabeçalho
  doc.rect(margin, margin, pageWidth - 2 * margin, 20);

  // Detalhes principais
  const detailsStartY = margin + 30;
  const dataEmissaoFormatada = formatDatePDF(data[0].DataEmissao);
  const dataDespachoFormatada = formatDatePDF(data[0].DataDespacho);
  const veiculoProprio = data[0].VeiculoProprio ? "Sim" : "Não";

  doc.text(`Responsável Separação: ${data[0].ResponsavelSeparacao}`, margin + padding, detailsStartY);
  doc.text(`Responsável Despacho: ${data[0].ResponsavelDespacho}`, margin + padding, detailsStartY + 10);
  doc.text(`Data Emissão: ${dataEmissaoFormatada}`, margin + padding, detailsStartY + 20);
  doc.text(`Data Despacho: ${dataDespachoFormatada}`, margin + padding + 80, detailsStartY + 20);
  doc.text(`Veículo Próprio: ${veiculoProprio}`, margin + padding, detailsStartY + 30);
  doc.text(`Placa Veículo: ${data[0].PlacaVeiculo}`, margin + padding + 50, detailsStartY + 30);
  doc.text(`Frete: ${data[0].Frete}`, margin + padding + 100, detailsStartY + 30);
  doc.text(`Observações: ${data[0].Observacoes}`, margin + padding, detailsStartY + 40);

  // Desenha borda da seção de detalhes principais
  doc.rect(margin, detailsStartY - 5, pageWidth - 2 * margin, 60);

  vendas.sort((a, b) => {
    const municipioA = (a.Municipio || "Sem Municipio").toLowerCase();
    const municipioB = (b.Municipio || "Sem Municipio").toLowerCase();
    if (municipioA < municipioB) return -1;
    if (municipioA > municipioB) return 1;
    return 0;
  });


  // Tabela de pedidos
  let startY = detailsStartY + 60;
  vendas.forEach(item => {
    // Dados da venda principal
    const vendaData = [
      [
        item.Codigo.toString(),
        item.Cliente,
        item.Municipio || "Sem Municipio",
        item.UF || "Sem região",
        item.FormadePagamento || "Sem forma de Pagamento",
        formatarValor(item.ValorFinal),
        item.cliente[0] && item.cliente[0].PessoaGrupo ? item.cliente[0].PessoaGrupo : "Sem Grupo"
      ]
    ];

    doc.autoTable({
      startY: startY,
      head: [['Nº Pedido', 'Cliente', 'Município', 'UF', 'Forma de Pagamento', 'Valor Final', 'Grupo Cliente']],
      body: vendaData,
      styles: { fontSize: 8, halign: 'center', valign: 'middle' },
      columnStyles: {
        1: { halign: 'left' }  // Alinha a coluna Cliente à esquerda
      },
      headStyles: { fillColor: [211, 211, 211], textColor: [0, 0, 0] },
      didDrawCell: function (data) {
        doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height);
      }
    });

    // Cabeçalho e dados dos produtos da venda
    const produtosData = item.venda_produtos.map(produto => [
      produto.Codigo,
      produto.Descricao,
      produto.Quantidade.toString(),
      formatarValor(produto.ValorTotal)
    ]);

    doc.autoTable({
      startY: doc.lastAutoTable.finalY,
      head: [['Código Produto', 'Descrição Produto', 'Quantidade', 'Valor Total']],
      body: produtosData,
      styles: { fontSize: 8, halign: 'center', valign: 'middle' },
      columnStyles: {
        1: { halign: 'left' }  // Alinha a coluna Descrição Produto à esquerda
      },
      headStyles: { fillColor: [211, 211, 220], textColor: [0, 0, 0] },
      didDrawCell: function (data) {
        doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height);
      }
    });

    // Atualiza a posição Y para a próxima venda
    startY = doc.lastAutoTable.finalY;
  });
  // Tabela de pedidos
  const finalY = doc.lastAutoTable.finalY;
  const pesoTotal = vendas.reduce((acc, item) => acc + item.venda_produtos.reduce((a, b) => a + b.PesoKG, 0), 0);
  const quantidade = vendas.reduce((acc, item) => acc + item.venda_produtos.reduce((a, b) => a + b.Quantidade, 0), 0);
  const valorTotal = vendas.reduce((acc, item) => acc + item.ValorFinal, 0);

  doc.text(`Peso Total: ${pesoTotal} KG`, margin + padding, finalY + 10);
  doc.text(`Quantidade: ${quantidade}`, margin + padding + 80, finalY + 10);
  doc.text(`Valor Total: ${formatarValor(valorTotal)}`, margin + padding + 140, finalY + 10);


  doc.line(margin, finalY + 15, pageWidth - margin, finalY + 15);

  doc.text(`Resumo de Pagamento`, margin + padding, finalY + 25);
  // Tabela de resumo de formas de pagamento
  const formasPagamento = {};
  vendas.map(item => {
    const formaPagamento = item.FormadePagamento || "Sem forma de Pagamento";
    if (!formasPagamento[formaPagamento]) {
      formasPagamento[formaPagamento] = 0;
    }
    formasPagamento[formaPagamento] += item.ValorFinal;
  });

  console.log(formasPagamento)

  const formasPagamentoData = Object.entries(formasPagamento).map(([forma, valorTotal]) => [
    forma,
    formatarValor(valorTotal)
  ]);

  console.log(formasPagamentoData)

  doc.autoTable({
    startY: finalY + 20,
    head: [['Forma de Pagamento', 'Valor Total']],
    body: formasPagamentoData,
    styles: { fontSize: 8, halign: 'center', valign: 'middle' },
    headStyles: { fillColor: [211, 211, 211], textColor: [0, 0, 0] },
    didDrawCell: function (data) {
      doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height);
    }
  });

  // Linha de assinatura
  const offsetY = doc.lastAutoTable.finalY + 10;
  doc.line(margin, offsetY, pageWidth - margin, offsetY);

  // Assinatura
  doc.text("Declaro ter conferido as mercadorias bem como as notas/pedidos sendo o responsável pela entrega", margin + padding, offsetY + 15);
  doc.text("e retorno dos documentos e pagamentos assinados e conferidos.", margin + padding, offsetY + 25);
  doc.text("Assinatura: ____________________________", margin + padding, offsetY + 35);

  // Salva o PDF
  doc.save("CargaResumo.pdf");
}


// function generatePdfPedidos(data, pedidos) {
//   const doc = new jsPDF();

//   console.log(data, pedidos);
//   const pageWidth = doc.internal.pageSize.getWidth();
//   const pageHeight = doc.internal.pageSize.getHeight();

//   // Data do dia
//   const currentDate = new Date().toLocaleString();

//   // Cabeçalho com bordas
//   doc.setFontSize(20);
//   doc.setFont('helvetica', 'bold');
//   const empresaUpperCase = data[0].Empresa.toUpperCase();
//   doc.text(empresaUpperCase, pageWidth / 2, 20, { align: 'center' });
//   doc.setFontSize(12);
//   doc.text(`Resumo de Carregamento - Listagem de Carga`, pageWidth / 2, 30, { align: 'center' });
//   doc.rect(5, 10, pageWidth - 10, 40);  // Borda do cabeçalho

//   // Data e quantidade de páginas
//   doc.setFontSize(10);
//   doc.setFont('helvetica', 'normal');
//   doc.text(`Data: ${currentDate}`, 10, 40);

//   // Informações do Veículo
//   doc.setFontSize(12);
//   doc.setFont('helvetica', 'bold');
//   doc.text(`Nº da Carga: ${data[0].Codigo}`, 10, 60);
//   doc.text(`Placa do Veiculo: ${data[0].PlacaVeiculo || 'Não informado'}`, 10, 70);

//   // Linha separadora
//   doc.line(5, 80, pageWidth - 5, 80);

//   // Texto "Listagem de Produtos"
//   const textWidth = doc.getTextWidth("Listagem de Produtos");
//   doc.text("Listagem de Produtos", (pageWidth - textWidth) / 2, 80 + 10); // Centralizando o texto

//   // Tabela de Produtos
//   const startY = 100;
//   let currentY = startY;
//   const colWidths = [20, 70, 30, 30, 30];

//   let rows = [];

//   // Objeto para acumular os produtos agrupados por Codigo
//   let aggregatedProducts = {};

//   // Primeiro loop para agrupar os produtos
//   pedidos.forEach(product => {
//     if (product.venda_produtos.length > 0) {
//       product.venda_produtos.forEach(produto => {
//         let codigo = produto.Codigo || '';
//         if (!aggregatedProducts[codigo]) {
//           aggregatedProducts[codigo] = {
//             Codigo: codigo,
//             Descricao: produto.Descricao || '',
//             Quantidade: 0,
//             PesoKG: 0,
//             ValorTotal: 0
//           };
//         }
//         aggregatedProducts[codigo].Quantidade += produto.Quantidade || 0;
//         aggregatedProducts[codigo].PesoKG += produto.PesoKG || 0;
//         aggregatedProducts[codigo].ValorTotal += produto.ValorTotal || 0;
//       });
//     }
//   });

//   // Segundo loop para preencher o array rows com os produtos agregados
//   for (let codigo in aggregatedProducts) {
//     let produto = aggregatedProducts[codigo];
//     rows.push([
//       produto.Codigo,
//       produto.Descricao,
//       produto.Quantidade,
//       produto.PesoKG,
//       produto.ValorTotal
//     ]);
//   }

//   // Adicionando a linha de total geral
//   const totalQuantity = rows.reduce((acc, row) => acc + (row[2] || 0), 0);
//   const totalPeso = rows.reduce((acc, row) => acc + (row[3] || 0), 0);
//   const totalValor = rows.reduce((acc, row) => acc + (row[4] || 0), 0);
//   rows.push([
//     'TOTAL GERAL',
//     '',
//     totalQuantity.toString(),
//     totalPeso.toString(),
//     totalValor
//   ]);

//   rows = rows.map(row => {
//     row[4] = formatarValor(row[4]);
//     return row;
//   });

//   // Configurações da tabela
//   const tableOptions = {
//     startY: currentY, // Ajuste para dar espaço abaixo do texto "Listagem de Produtos"
//     margin: { top: 10 },
//     bodyStyles: { valign: 'middle', halign: 'center' },
//     head: [['Codigo Produto', 'Produto', 'Quantidade', 'Peso', 'Valor']],
//     body: rows,
//     columns: colWidths.map((width, i) => ({ width, halign: 'center' })),
//     theme: 'grid',
//     // didDrawPage: function (data) {
//     //   // Adicionando linha superior para separar cabeçalho
//     //   doc.setDrawColor(0); // linha na cor preta
//     //   doc.setLineWidth(0.1);
//     //   doc.line(5, 95, pageWidth - 5, 95);
//     // }
//   };

//   doc.autoTable(tableOptions);

//   // Save the PDF
//   doc.save(`ResumoCarregamento${data[0].Codigo}.pdf`);
// }
function generatePdfPedidos(data, pedidos) {
  const doc = new jsPDF();

  const pageWidth = doc.internal.pageSize.getWidth();
  const currentDate = new Date().toLocaleString();

  // Cabeçalho
  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  const empresaUpperCase = data[0].Empresa.toUpperCase();
  doc.text(empresaUpperCase, pageWidth / 2, 20, { align: 'center' });
  doc.setFontSize(12);
  doc.text(`Resumo de Carregamento - Listagem de Carga`, pageWidth / 2, 30, { align: 'center' });
  doc.rect(5, 10, pageWidth - 10, 40);  

  // Data e informações
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(`Data: ${currentDate}`, 10, 40);

  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text(`Nº da Carga: ${data[0].Codigo}`, 10, 60);
  doc.text(`Placa do Veiculo: ${data[0].PlacaVeiculo || 'Não informado'}`, 10, 70);

  // Linha separadora
  doc.line(5, 80, pageWidth - 5, 80);

  // Texto "Listagem de Produtos"
  const textWidth = doc.getTextWidth("Listagem de Produtos");
  doc.text("Listagem de Produtos", (pageWidth - textWidth) / 2, 90);

  // ---- Agrupamento ----
  let groupedByPrateleira = {};

  pedidos.forEach(product => {
    if (product.venda_produtos.length > 0) {
      product.venda_produtos.forEach(produto => {
        let codigo = produto.Codigo || '';
        let prateleira = produto.Prateleira || "Sem Prateleira informada";

        if (!groupedByPrateleira[prateleira]) {
          groupedByPrateleira[prateleira] = {};
        }

        if (!groupedByPrateleira[prateleira][codigo]) {
          groupedByPrateleira[prateleira][codigo] = {
            Codigo: codigo,
            Descricao: produto.Descricao || '',
            Quantidade: 0,
            PesoKG: 0,
            ValorTotal: 0
          };
        }

        groupedByPrateleira[prateleira][codigo].Quantidade += produto.Quantidade || 0;
        groupedByPrateleira[prateleira][codigo].PesoKG += produto.PesoKG || 0;
        groupedByPrateleira[prateleira][codigo].ValorTotal += produto.ValorTotal || 0;
      });
    }
  });

  // Monta as linhas
  let rows = [];
  let totalQuantity = 0, totalPeso = 0, totalValor = 0;

  for (let prateleira in groupedByPrateleira) {
    // Linha título da prateleira
    rows.push([
      { content: `Prateleira: ${prateleira}`, colSpan: 5, styles: { halign: 'left', fillColor: [200, 200, 200], fontStyle: 'bold' } }
    ]);

    for (let codigo in groupedByPrateleira[prateleira]) {
      let produto = groupedByPrateleira[prateleira][codigo];
      rows.push([
        produto.Codigo,
        produto.Descricao,
        produto.Quantidade,
        produto.PesoKG,
        formatarValor(produto.ValorTotal)
      ]);

      totalQuantity += produto.Quantidade;
      totalPeso += produto.PesoKG;
      totalValor += produto.ValorTotal;
    }
  }

  // Linha total geral
  rows.push([
    'TOTAL GERAL',
    '',
    totalQuantity.toString(),
    totalPeso.toString(),
    formatarValor(totalValor)
  ]);

  // Tabela
  doc.autoTable({
    startY: 100,
    margin: { top: 10 },
    head: [['Código Produto', 'Produto', 'Quantidade', 'Peso', 'Valor']],
    body: rows,
    theme: 'grid',
    bodyStyles: { valign: 'middle', halign: 'center' },
    columnStyles: {
      0: { cellWidth: 30 },
      1: { cellWidth: 70 },
      2: { cellWidth: 30 },
      3: { cellWidth: 30 },
      4: { cellWidth: 30 }
    }
  });

  // Salvar
  doc.save(`ResumoCarregamento${data[0].Codigo}.pdf`);
}


async function gerarPdfCarga(id) {
  try {
    const token = await AsyncStorage.getItem('@storage_Key');
    if (!token) {
      alert("Usuário não autenticado");
      return;
    }
    const params = { user: token, id: id };
    const response = await api.get('/editar-carga', { params, timeout: 1000000 });

    console.log(response.data[1]);
    

    const registros = response.data[0];
    const vendas = response.data[1];

    if (!registros.length) {
      alert("Nenhum dado encontrado para esta carga.");
      return;
    }

    generatePdfPedidos(registros, vendas);
  } catch (error) {
    console.error(error);
    alert("Erro ao gerar PDF");
  }
}


export default function UserReports() {

  const [analitico, setAnalitico] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [empresa, setEmpresa] = useState([]);
  const [mes, setMes] = useState(getMesAtual());
  const [diaAtual, setDia] = useState('');
  const [filtros, setFiltros] = useState({});
  const [totalItems, setTotalItems] = useState(0);
  const [inicio, setInicio] = useState('');
  const [fim, setFim] = useState('');
  const [TipoData, setTipoData] = useState('DataEmissao');
  const [generoProd, setGeneroProd] = useState("00 – Mercadoria para Revenda");
  const history = useHistory();
  const [token, setToken] = useState('');
  const [dados, setDados] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState('');
  const [excel, setExcel] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [camposTotal, setCampos] = useState('');
  const [selectedValues, setSelectedValues] = useState([]);
  const [valores, setValores] = useState({});
  const [anos, setAnos] = useState();

  const [filtrosExpedicao, setFiltrosExpedicao] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const [update, setUpdate] = useState(false);
  const [deleteTrigger, setDeleteTrigger] = useState(false);


  const openModal = (data) => {
    setSelectedUser(data); // Define o usuário selecionado
    console.log(data);
    setIsModalOpen(true);
  };

  async function excluiCarga(data) {
    const key = await getData();

    const param = {};
    param.user = key
    param.id = data

    const response = await api.delete('/excluir-carga', { params: param, timeout: 1000000 });

    // setSelectedUser(data); // Define o usuário selecionado
    // console.log(response);
    // setIsModalOpen(true);
    setDeleteTrigger(true);
  };

  useEffect(() => {
    if (deleteTrigger) {
      setUpdate(prev => !prev);  // Troque o valor de 'update' para ativar o useEffect principal
      setDeleteTrigger(false);   // Resete o gatilho
    }
  }, [deleteTrigger]);

  const closeModal = () => {
    setSelectedUser(null); // Reseta o usuário selecionado
    setIsModalOpen(false);
  };

  const optionsStatus = [
    { value: 0, label: 'Aguardando' },
    { value: 2, label: 'Separação' },
    { value: 4, label: 'Despachada' },
  ];

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const handleValuesSelected = (values) => {
    setSelectedValues(values);
  };

  const handleClickExcel = () => {
    gerarExcel(excel, total);
  };

  const handleClickPdf = () => {
    generatePDF(excel, total, filtros);
  };

  const addCodigosToDataArray = (dataArray) => {
    dataArray.forEach(data => {
      const uniqueCodigoVendas = new Set();

      if (data.items && Array.isArray(data.items)) {
        data.items.forEach(item => {
          if (item.CodigoVenda !== undefined) {
            uniqueCodigoVendas.add(item.CodigoVenda);
          }
        });
      }

      data.Codigos = `(${[...uniqueCodigoVendas].join(' , ')})`;
    });

    return dataArray;
  };

  async function index(data) {

    // console.log(data)
    const pedidos = addCodigosToDataArray(data)
    // console.log(pedidos)
    const dados_formatados = await generateTableData(pedidos, diaAtual)
    // console.log(dados_formatados);
    setCampos(dados_formatados)
    const objFinal = removeObjectsByKey(dados_formatados, selectedValues)
    // console.log(dados_formatados)
    const totais = calcularTotalizadores(objFinal)

    setExcel(objFinal)
    setTotal(totais)

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const itemsToShow = objFinal.slice(startIndex, endIndex);
    // console.log(itemsToShow);
    setAnalitico(itemsToShow)
  }

  const getData = async () => {
    try {
      const value = await AsyncStorage.getItem('@storage_Key')
      if (value !== null) {
        return value;// value previously stored
      }
    } catch (e) {
      // error reading value
    }
  }


  useEffect(async () => {
    const param = {};
    const key = await getData();

    const currentDate = new Date();
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    const formattedFirstDay = formatDate(firstDayOfMonth);
    const formattedLastDay = formatDate(lastDayOfMonth);

    setInicio(formattedFirstDay);
    setFim(formattedLastDay);

    if (typeof key !== 'undefined' && key !== null) {
      param.user = key;
      setFiltros(param);

      const fetchData = async () => {
        setIsLoading(true);

        try {
          const [filtrosData, dadosData, dadosLogisticaResp] = await Promise.all([
            api.get('/filtros-logistica', { params: param, timeout: 500000 }),
            api.get('/logistica', { params: param, timeout: 5000000 }),
            api.get('/dados-logistica', { params: param, timeout: 500000 })
          ]);

          const filtros = filtrosData.data[0];
          // console.log(filtros)
          const emp = filtros.map(pessoas => ({
            value: pessoas._id,
            label: pessoas.NomeFantasia
          }));

          setFiltrosExpedicao(dadosLogisticaResp);

          const selectEmpresas = document.getElementById("select-empresas");
          filtros.forEach(empresa => {
            const option = document.createElement("option");
            option.value = empresa._id;
            option.text = empresa.NomeFantasia;
            selectEmpresas.appendChild(option);
          });

          console.log(empresa)
          const dados = dadosData.data[0];
          // setValores(options)
          // console.log(dados)

          setToken(key);
          setDados(dados);
          setTotalItems(dados.length);
          setAnos(obterAnoAtual());

          if (currentPage === 1) {
            await index(dados);
          }
        } catch (error) {
          console.error(error);
        } finally {
          setIsLoading(false);
        }
      };

      fetchData();
    } else {
      history.push('/');
    }
  }, [isModalOpen, update]);

  //executa a paginação na alteração de seus estados
  useEffect(() => {
    index(dados);
  }, [currentPage, itemsPerPage, selectedValues]);

  //aplica os filtros
  const handleFilter = async () => {
    const data = {}

    if ((typeof token !== 'undefined') && token !== null) {
      data.user = token

      if ((selected !== '') && selected !== null) {
        data.status = selected
      }

      if ((TipoData !== '') && TipoData !== null) {
        data.tipoData = TipoData
      }

      if ((empresa !== '') && empresa !== null) {
        data.empresa = empresa
      }

      if (inicio !== null && inicio !== '') {
        if (fim !== null && fim !== '') {
          data.fim = fim
          data.inicio = inicio
        } else {
          alert("preencher os dois periodos");
        }
      }

      setFiltros(data)

      if (Object.keys(data).length !== 0) {
        setCurrentPage(1)
        setItemsPerPage(20)
      }

      try {
        setIsLoading(true);
        api.get('/logistica', { params: data, timeout: 1000000 })
          .then(response => {
            console.log(response.data[0])

            if (response.data.length !== 0) {
              // console.log(response.data[0])
              setDados(response.data[0]);
              setTotalItems(response.data.length);
            } else {
              setDados(response.data[0]);
              handlePageChange(1)
              setTotalItems(20);
            }

            if (currentPage === 1) {
              index(response.data[0]);
            }
          })
          .catch(error => {
            console.error(error);
          }).finally(() => {
            setIsLoading(false)
          });;

        // console.log(data[0].length)
      } catch (error) {
        console.error(error);
      }
    } else {
      history.push('/');
    }
  }

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // handleSubmit(); // Atualiza os dados ao alterar a página
  };

  const handleItemsPerPageChange = (newItens) => {
    setItemsPerPage(newItens);
    setCurrentPage(1); // Reset currentPage when changing items per page
    // handleSubmit();
  };
  const [selected, setSelected] = useState([]);

  return (
    <Box mt={{ sm: '140px', md: '12%', lg: '15%', xl: '6%' }}>
      {isLoading && (
        <Box
          position="fixed"
          top="0"
          left="0"
          right="0"
          bottom="0"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bg="rgba(0, 0, 0, 0.5)" // Define a cor de fundo como transparente com um leve tom escuro (50% de opacidade)
          zIndex="9999"
        >
          <Spinner
            thickness="4px"
            speed="0.65s"
            color="blue.500"
            size="xl"
          />
        </Box>
      )}
      <SimpleGrid
        columns={[1, 2, 3, 5]}
        spacing={5} mb={5}
        bg={"gray.200"} rounded="md" p={5}
      // border="1px solid black"
      >
        <Box>
          <FormControl>
            <FormLabel fontSize={{ sm: "12px" }} fontWeight="bold">Status da Carga:</FormLabel>
            <MultiSelect
              options={optionsStatus}
              value={selected}
              onChange={setSelected}
              hasSelectAll={false}
              // hasSelectAll={false}
              disableSearch={false}
              overrideStrings={
                {
                  "allItemsAreSelected": "Todos",
                  "clearSearch": "Limpar Pesquisa",
                  "clearSelected": "Limpar Selecionado",
                  "noOptions": "Sem opções",
                  "search": "Pesquisar",
                  "selectAll": "Todos",
                  "selectAllFiltered": "Select All (Filtered)",
                  "selectSomeItems": "Selecione",
                  "create": "Criar",
                }
              }
            />
          </FormControl>
        </Box>
        <Box>
          <FormControl>
            <FormLabel fontSize={{ sm: "12px" }} fontWeight="bold">Empresas:</FormLabel>
            <Select bg={"white"} id="select-empresas" onChange={(e) => setEmpresa(e.target.value)}>
              <option value="">Todas</option>
            </Select>
          </FormControl>
        </Box>
        <Box>
          <FormControl>
            <FormLabel fontSize={{ sm: "12px" }} fontWeight="bold">Tipo Data:</FormLabel>
            <Select bg={"white"} id="select-data" onChange={(e) => setTipoData(e.target.value)}>
              <option value="DataEmissao">Data Emissão</option>
              <option value="DataDespacho">Data Despacho</option>
            </Select>
          </FormControl>
        </Box>
        <Box>
          <FormControl>
            <FormLabel fontSize={{ sm: "12px" }} fontWeight="bold">Início do Período:</FormLabel>
            <Input bg={"white"} type="date" id="inicio" value={inicio} onChange={(e) => setInicio(e.target.value)} />
          </FormControl>
        </Box>
        <Box>
          <FormControl>
            <FormLabel fontSize={{ sm: "12px" }} fontWeight="bold">Fim do Período:</FormLabel>
            <Input bg={"white"} type="date" id="Fim" value={fim} onChange={(e) => setFim(e.target.value)} />
          </FormControl>
        </Box>
        <Box mt="auto">
          <Button colorScheme="blue" onClick={handleFilter}>Filtrar</Button>
        </Box>
      </SimpleGrid>

      <SimpleGrid mt='1%'>
        <Button size="sm" w="10%"
          onClick={handleOpenModal}
          border="1px solid black"
        >Selecionar Campos</Button>
        <ModalComponent
          data={camposTotal}
          onValuesSelected={handleValuesSelected}
          isOpen={isOpen}
          onClose={handleCloseModal}
          selectedValues={selectedValues}
        />
        {/* <ModalComponent data={analitico} onValuesSelected={handleValuesSelected} isOpen={isOpen} onClose={handleCloseModal} valuesCheck={selectedValues} /> */}
        <Box mt='1%'>
          <Text fontWeight="bold">Valores Retirados: {selectedValues.length > 0 ? selectedValues.join(', ') : 'Nenhum valor selecionado'}</Text>
        </Box>
      </SimpleGrid>
      <SimpleGrid mt='2%'>
        <TableContainer w='100%' overflowX="auto" >
          {analitico && total && (
            <DataDisplay data={analitico} total={total} onclick={openModal} excluir={excluiCarga} gerarPDF={gerarPdfCarga} />
          )}
        </TableContainer>
      </SimpleGrid>
      <Box display='flex'>
        <Pagination
          totalItems={totalItems}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          onPageChange={handlePageChange}
          onLimitChange={handleItemsPerPageChange}
        />
        <Button mt={4}
          colorScheme="blue" mb="5%"
          mr={1} size="sm" fontSize={{ sm: "10px" }}
          leftIcon={<DownloadIcon />}
          onClick={() => openModal()}>Novo</Button>
        {/* <Button
         mt={4} colorScheme="blue" mb="5%" size="sm"
         fontSize={{ sm: "10px" }} leftIcon={<DownloadIcon />} 
         onClick={handleClickPdf}>PDF</Button> */}
      </Box>

      <Modal isOpen={isModalOpen} onClose={closeModal} size="xl">
        <ModalOverlay />
        <ModalContent
          // margin="auto"
          maxW="90%"
        // height="100%"
        >
          <ModalHeader>{selectedUser ? 'Editando uma Carga' : 'Montagem de Carga'}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <CadastroExpedicao ID={selectedUser} onClose={() => closeModal()} filtros={filtrosExpedicao} /> {/* Passa o usuário selecionado para o componente Form */}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
}
